import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { AppService } from '../../../../../services';
import { AccApplicationDialogDataService } from '../../../acc-application-dialog/acc-application-dialog-data.service';
import { PersonDialogDataService } from '../../person-dialog-data.service';
import { getSetup } from "./grid/get-setup";


@Component({
	selector: 'person-engagements-part',
	standalone: true,
	imports: [
		TabStripModule,
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-engagements.part.html'
})

export class PersonEngagementsPart implements OnInit {

	public dialogBodyHeight = input.required<number>();

	public personDialogDataService = inject(PersonDialogDataService);
	private accApp = inject(AccApplicationDialogDataService);
	private util = inject(UtilityService);
	private readonly dialog = inject(DialogService);
	private readonly app = inject(AppService);

	public setup = getSetup(this.personDialogDataService, this.accApp, this.util, this.dialog, this.app);

	// subtracting 70 to account for padding and tabstrip
	public customHeight = computed(() => this.dialogBodyHeight() - 70);

	public allEngagements = computed(() => this.personDialogDataService.allEngagements());

	async ngOnInit() {
		const personDetails = this.personDialogDataService.personDetails();
		if (personDetails) {
			await this.personDialogDataService.getAllEngagementsByPerson(personDetails.personId);
		}
	}
}